import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { SagaProvider } from 'react-async-client';
import cx from 'classnames';
import { BrowserRouter as Router } from 'react-router-dom';
import { Trans } from 'react-i18next';

import { sagaMiddleware } from '../store/middlewares';
import OPD from './OPD';
import { pushRollbarError } from '../utils/rollbar';
import i18n from '../utils/i18n';

const initialAppState = {
    error: null,
    info: null
};

export default class App extends Component {
    static propTypes = {
        store: PropTypes.object
    };

    state = initialAppState;

    resetError = () => this.setState(initialAppState);

    componentDidCatch(error, info) {
        pushRollbarError(error, info);
        this.setState({ error, info });
    }

    render() {
        const { store } = this.props;

        return this.state.error ? (
            <div>
                <h3><Trans i18nKey='appError' /></h3>
                <p>{this.state.error || ''}</p>
                <p>{this.state.info || ''}</p>
                <button onClick={this.resetError}><Trans i18nKey='appReload' /></button>
            </div>
        ) : (
            <SagaProvider sagaMiddleware={sagaMiddleware}>
                <Provider store={store}>
                    <Router>
                        <div className={cx('opd')}>
                            <OPD i18n={i18n} />
                        </div>
                    </Router>
                </Provider>
            </SagaProvider>
        );
    }
}
